module.exports = __webpack_public_path__ + "img/docAppointRes_e.80b26d7f.png";